module.exports = __webpack_public_path__ + "images/List.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/List.png
// module id = 131
// module chunks = 0 1